module.exports = __webpack_public_path__ + "img/acessibilidade-popover.eb02d606.svg";